import { render, staticRenderFns } from "./userSegmentationGrowth.vue?vue&type=template&id=1e0fc131&scoped=true&"
import script from "./userSegmentationGrowth.vue?vue&type=script&lang=js&"
export * from "./userSegmentationGrowth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0fc131",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e0fc131')) {
      api.createRecord('1e0fc131', component.options)
    } else {
      api.reload('1e0fc131', component.options)
    }
    module.hot.accept("./userSegmentationGrowth.vue?vue&type=template&id=1e0fc131&scoped=true&", function () {
      api.rerender('1e0fc131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userSegmentationGrowth.vue"
export default component.exports